import { useEffect, useState } from "react";
import useB2BTranslation from "../../../../b2b-common/hooks/useB2BTranslation";
import useGettingWidgetData from "../../../hooks/useGettingWidgetData";
import WIDGT_AIND_QUANT_02_WidgetLayout from "./WIDGT_AIND_QUANT_02_WidgetLayout";

const WIDGT_AIND_QUANT_02_Widget = ({ widget, atPublicDashboard = false, password = null }) => {

    const { widgetData, loading } = useGettingWidgetData(widget, atPublicDashboard, password);
    const { t } = useB2BTranslation('b2b-reporting');
    const [areaIndicatorData, setAreaIndicatorData] = useState(null);
    const [objectiveData, setObjectiveData] = useState(null);

    useEffect(() => {
        if (!widgetData) return;
        setAreaIndicatorData(widgetData.widgetResponse.areaIndicatorDTO);
        setObjectiveData(widgetData.widgetResponse.objectiveDTO);
    }, [widgetData]);

    return (
        <WIDGT_AIND_QUANT_02_WidgetLayout
            areaIndicatorData={areaIndicatorData}
            objectiveData={objectiveData}
            loading={loading}
            atPublicDashboard={atPublicDashboard}
            className={`widget-WIDGT_AIND_QUANT_02`}
        />
    )
};

export default WIDGT_AIND_QUANT_02_Widget;